export default __webpack_public_path__ + "static/bernadette1-6c9b8e1d9e8b349f7e19acdac6a2189e.jpg";